import { NotificationEventEnum } from '.'
import { RFIStatus } from '../statuses/rfi'
import { NotificationEventItem } from './NotificationEventItem'
import { CommentedNotificationEventItem } from './common/commented'
import { EditedNotificationEventItem } from './common/edited'
import { RevertedNotificationEventItem } from './common/reverted'

const rfi = 'Request For Information' as const

const Submitted = new NotificationEventItem({
  id: '7168AF2C-168F-4906-A169-F5B59FC44341',
  name: 'Submitted',
  description: `A ${rfi} is sent from ${RFIStatus.Draft.name} to ${RFIStatus.PendingResponses.name}`,
})

const Edited = EditedNotificationEventItem({
  id: '532A9C44-2DFE-4496-81E1-B1B45EC3A5A9',
  editable: rfi,
})

const Reverted = RevertedNotificationEventItem({
  id: 'B7959E84-CCD9-4805-B16B-547CBA8D2F24',
  revertable: rfi,
  from: [RFIStatus.Closed, RFIStatus.Unlocked, RFIStatus.PendingResponses],
  to: [RFIStatus.PendingResponses, RFIStatus.Draft],
})

const Response = new NotificationEventItem({
  id: 'A41FC361-30F1-4A84-A537-D643B81AE323',
  name: 'Response',
  description: `A response is made to a ${rfi}`,
})

const Closed = new NotificationEventItem({
  id: 'EF5258D4-48A1-4AFA-87F1-F876F69A250B',
  name: 'Closed',
  description: 'All Response Disciplines mark their responses as complete',
})

const Commented = CommentedNotificationEventItem({
  id: '33A0989B-AB27-4436-9F7A-CA42C130D105',
  commentable: rfi,
})

export type RFINotificationEventItem =
  | typeof Submitted
  | typeof Edited
  | typeof Reverted
  | typeof Response
  | typeof Closed
  | typeof Commented

class RFINotificationEventEnum extends NotificationEventEnum<
  'RFINotification',
  RFINotificationEventItem,
  RFINotificationEventItem['name'],
  RFINotificationEventItem['id']
> {
  readonly typename = 'RFINotification'
  get values() {
    return [
      this.Submitted,
      this.Edited,
      this.Reverted,
      this.Response,
      this.Closed,
      this.Commented,
    ]
  }
  readonly Submitted = Submitted
  readonly Edited = Edited
  readonly Reverted = Reverted
  readonly Response = Response
  readonly Closed = Closed
  readonly Commented = Commented
}

export const RFINotificationEvent = new RFINotificationEventEnum()
